import { Injectable } from '@angular/core';
import { CityActions } from '@city/data-access';
import { CityService } from '@city/feature';
import { EnvironmentService } from '@core/feature';
import { InfoblockActions, OccInfoblocksService } from '@main/infoblock/data-access';
import { Actions, EffectNotification, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { AuthActions } from '@spartacus/core';
import { EMPTY, Observable, iif, of } from 'rxjs';
import { catchError, filter, map, switchMap } from 'rxjs/operators';

@Injectable()
export class InfoblockEffects {
  load$: Observable<InfoblockActions.LoadInfoblocksSuccess | InfoblockActions.LoadInfoblocksFail> = createEffect(() =>
    this.actions$.pipe(
      ofType(InfoblockActions.LOAD_INFOBLOCKS),
      filter((action: InfoblockActions.LoadInfoblocks) => !!action.cityId),
      switchMap((action: InfoblockActions.LoadInfoblocks) => {
        const { cityId } = action;

        return this.occInfoblocksService.load().pipe(
          map((response) => {
            return new InfoblockActions.LoadInfoblocksSuccess(cityId, response);
          }),
          catchError((response) => {
            return of(new InfoblockActions.LoadInfoblocksFail(cityId, response));
          }),
        );
      }),
    ),
  );

  reloadOnLoginLogout$: Observable<InfoblockActions.LoadInfoblocks> = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthActions.LOGIN, AuthActions.LOGOUT),
      concatLatestFrom(() => this.cityService.activeBaseStoreCode$),
      map(([, baseStoreCode]) => new InfoblockActions.LoadInfoblocks(baseStoreCode)),
    ),
  );

  reloadOnCityChange$: Observable<InfoblockActions.LoadInfoblocks> = createEffect(() =>
    this.actions$.pipe(
      ofType(CityActions.SET_ACTIVE_BASE_STORE),
      map((action: CityActions.SetActiveBaseStore) => action.payload),
      map((baseStoreCode) => new InfoblockActions.LoadInfoblocks(baseStoreCode)),
    ),
  );

  constructor(
    private actions$: Actions,
    private occInfoblocksService: OccInfoblocksService,
    private environmentService: EnvironmentService,
    private cityService: CityService,
  ) {}

  ngrxOnRunEffects(resolvedEffects$: Observable<EffectNotification>): Observable<EffectNotification> {
    return iif(() => this.environmentService.isPlatformBrowser, resolvedEffects$, EMPTY);
  }
}
